import { AsyncPipe } from '@angular/common';
import { Component, OnInit, Type, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { catchError, combineLatest, of, shareReplay, switchMap, tap } from 'rxjs';
import { PanelService } from 'src/app/dashboards/panels/services/panel/panel.service';
import { VisibleDirective, waitUntilVisible } from 'src/app/panels/directives/visible/visible.directive';
import { IClimateCardBase } from 'src/app/panels/models/cards';
import { PanelType } from 'src/app/panels/models/panel-type';
import { ClimateBadgePipe } from 'src/app/panels/pipes/climate-badge.pipe';
import { ClimateIconClassPipe } from 'src/app/panels/pipes/climate-icon-class.pipe';
import { ClimateIconPipe } from 'src/app/panels/pipes/climate-icon.pipe';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { ErrorMessageComponent } from 'src/app/shared/components/error-message/error-message.component';
import { PanelComponent } from '../../panel.component';

export const CLIMATE_CARD_PANEL_IMPORTS: Type<unknown>[] = [
  CardComponent,
  VisibleDirective,
  ErrorMessageComponent,
  AsyncPipe,
  ClimateBadgePipe,
  ClimateIconPipe,
  ClimateIconClassPipe,
  RouterLink,
];

@Component({
  selector: 'app-climate-card-panel',
  templateUrl: './climate-card-panel.component.html',
  styleUrls: ['./climate-card-panel.component.scss'],
  imports: CLIMATE_CARD_PANEL_IMPORTS,
  host: {
    class: 'col-12',
  },
})
export abstract class ClimateCardPanelComponent extends PanelComponent implements OnInit {
  protected climateData: IClimateCardBase[] = [];
  protected message: string | null = null;

  protected panelService = inject(PanelService);

  protected get showBadges(): boolean {
    return this.getType() !== PanelType.WeatherStationOutsideClimateCard;
  }

  ngOnInit(): void {
    this.data$ = combineLatest([this.dashboardParams$, this.visible$]).pipe(
      waitUntilVisible(this),
      switchMap((params) => {
        return this.panelService
          .getClimateCard(this.getType(), this.entityIds, params.timeRange.from, params.timeRange.till)
          .pipe(
            catchError(() => {
              this.error = 'Geen data';
              return of(null);
            }),
          );
      }),
      tap((data) => {
        this.climateData = data?.cards || [];
        this.message = data?.message || null;
        this.loading = false;
      }),
      shareReplay(1),
    );
  }
}
